import { Component, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { EducationDetailsService } from './education-details.service';
import { HecResponse } from '../../../../../shared/shared-interfaces/hecResponse';
import { HEC_CONSTANTS } from '../../../../../utilities/constants';
import { SharedService } from '../../../../../shared/sharedServices/shared.service';
import { Router } from '@angular/router';
import { LoaderService } from '../../../../../shared/sharedServices/loader.service';
import { encrypt } from '../../../../../utilities/utilityFunctions';
import { DegreeAttestEduService } from '../../../das/services/degree-attest-edu.service';

@Component({
  selector: 'kt-education-details',
  templateUrl: './education-details.component.html',
  styleUrls: ['./education-details.component.scss']
})
export class EducationDetailsComponent implements OnInit {
  public formViewType: any
  public newEducationAddFormDisplay: boolean = false;
  public step = 0;
  public data;
  public educationDetailGridData: any;
  public educationDetailsData: any;
  public viewform: boolean = false;
  public isAlertVisible: boolean = false;
  public alertType: string;
  public alertIcon: string;
  public alertMsgValue: string;
  public dateError: string = '';
  public selectedDateError: boolean = false;
  @Input('dropdownList') dropdownList: any;
  public formType: string = 'cp';
  constructor(private educationDetailsService: EducationDetailsService,private degreeAttestService:DegreeAttestEduService,
    private cdr: ChangeDetectorRef, private sharedServices: SharedService, private router: Router, private loaderService: LoaderService) { }

  async ngOnInit() {
    window.scroll(0, 0)
    this.getEducationDetails();
  }

  public getEducationDetails() {
    this.loaderService.setValue(true);
    this.educationDetailsService.getEducationDetails().subscribe(
      (res: HecResponse) => {
        if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
          this.educationDetailGridData = res.data;
          this.data = res.data;
          this.loaderService.setValue(false);
          this.cdr.detectChanges();
          this.cdr.markForCheck();
        } else {
          this.loaderService.setValue(false);
          this.cdr.detectChanges();
        }
      },
      (err) => {
        this.loaderService.setValue(false);
        this.cdr.detectChanges();
      }
    )
  }

  public async openEducationDetails(data, index, type) {
    this.formViewType = type;
    this.educationDetailsData = data;
    this.viewform = true;
    this.cdr.detectChanges();
  }

  public deleteEducation(educationData) {
    this.loaderService.setValue(true);
    this.isAlertVisible = false;
    educationData.activeIndicator = false;
    let payload = {
      data: educationData
    };
    this.sharedServices.saveOrUpdateEducation(payload).subscribe(
      (res: HecResponse) => {
        if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
          this.getEducationDetails();
        } else {
          this.loaderService.setValue(false);
          this.alertMsgValue = HEC_CONSTANTS.MESSGAES_LIST.profileMessages.ERROR_EDUCATION_DELETE;
          this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
          // this.isAlertVisible = true;
          this.sharedServices
							.openPopupDialog(
								'ERROR',
								HEC_CONSTANTS.MESSGAES_LIST.profileMessages.ERROR_EDUCATION_DELETE,
								HEC_CONSTANTS.ERROR_TYPES.error
							)
							.then((res) => {

							});
          this.cdr.detectChanges();
        }
      },
      (err) => {
        this.loaderService.setValue(false);
        this.alertMsgValue = HEC_CONSTANTS.MESSGAES_LIST.profileMessages.ERROR_EDUCATION_DELETE;
        this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
        // this.isAlertVisible = true;
        this.sharedServices
							.openPopupDialog(
								'ERROR',
								HEC_CONSTANTS.MESSGAES_LIST.profileMessages.ERROR_EDUCATION_DELETE,
								HEC_CONSTANTS.ERROR_TYPES.error
							)
							.then((res) => {

							});
        this.cdr.detectChanges();
      }
    )
  }

  public getDate(date): any {
    let convertedDate = new Date(date).toISOString();
    return convertedDate;
  }

  public getEduDate(date): any {
    for (let i = 0; i < this.educationDetailGridData.length; i++) {
      if (new Date(date).getFullYear() + '-' + (new Date(date).getMonth() + 1) + '-' + new Date(date).getDate() >=
        new Date(this.educationDetailGridData[i].startDate).getFullYear() + '-' + (new Date(this.educationDetailGridData[i].startDate).getMonth() + 1) + '-' + new Date(this.educationDetailGridData[i].startDate).getDate()
        && new Date(date).getFullYear() + '-' + (new Date(date).getMonth() + 1) + '-' + new Date(date).getDate()
        <= new Date(this.educationDetailGridData[i].endDate).getFullYear() + '-' + (new Date(this.educationDetailGridData[i].endDate).getMonth() + 1) + '-' + new Date(this.educationDetailGridData[i].endDate).getDate()
      ) {
        this.dateError = this.educationDetailGridData[i].qualificationLevel;
        this.selectedDateError = true;
        this.cdr.detectChanges();
        this.cdr.markForCheck();
      } else {
        this.selectedDateError = false;
        this.dateError = undefined
        this.cdr.detectChanges();
      }
    }
  }

  public goToDegreeAttest(data) {
    this.degreeAttestService.setEducationData(data);
    this.router.navigate(['/das-app'])
  }

  public addNewEducation() {
    this.formViewType = 'new';
    this.educationDetailsData = [];
    this.viewform = true;
    this.cdr.detectChanges();
    this.cdr.markForCheck();
  }

  public goToDas():void{
    this.router.navigate(['/das-app'])
  }

  public getUpdatedEducation(educationStatus) {
    this.viewform = false;
    this.isAlertVisible = false;
    if (educationStatus.id) {
      this.alertMsgValue = HEC_CONSTANTS.MESSGAES_LIST.profileMessages.EDUCATION_SUCCESS;
      this.alertType = HEC_CONSTANTS.ERROR_TYPES.success;
      // this.isAlertVisible = true;
      this.sharedServices
							.openPopupDialog(
								'SUCCESS',
								HEC_CONSTANTS.MESSGAES_LIST.profileMessages.EDUCATION_SUCCESS,
								HEC_CONSTANTS.ERROR_TYPES.success
							)
							.then((res) => {

							});
    } else {
      this.alertMsgValue = HEC_CONSTANTS.MESSGAES_LIST.profileMessages.EDUCATION_SUCCESS;
      this.alertType = HEC_CONSTANTS.ERROR_TYPES.success;
      // this.isAlertVisible = true;
      this.sharedServices
							.openPopupDialog(
								'SUCCESS',
                HEC_CONSTANTS.MESSGAES_LIST.profileMessages.EDUCATION_ADDED_SUCCESS,
								HEC_CONSTANTS.ERROR_TYPES.success
							)
							.then((res) => {

							});
    }
    this.getEducationDetails();
    // setTimeout(() => {
    //   // this.isAlertVisible = false;
    //   this.cdr.detectChanges();
    // }, 3000)
  }

  public cancelEducation(event) {
    if (event == 'cancel') {
      this.viewform = false;
      this.cdr.detectChanges();
    }
  }

}
